import { render, staticRenderFns } from "./zhIndex.vue?vue&type=template&id=7c845285&scoped=true&"
import script from "./zhIndex.vue?vue&type=script&lang=js&"
export * from "./zhIndex.vue?vue&type=script&lang=js&"
import style0 from "./zhIndex.vue?vue&type=style&index=0&id=7c845285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c845285",
  null
  
)

export default component.exports